import React from 'react';
import { TermsAndConditions } from './TermsAndConditions';
import { useInstallerContext } from '../../../context/InstallerContext';
import { GeneralUserConsentLayout } from '../UserConsent';
import { useRenderControl } from '../../../context/InstallerRenderControlContext';
export const MarketingUserConsent = _ref => {
  let {
    shouldOpenNewWindow,
    onCloseButtonClick,
    onAgreeButtonClick
  } = _ref;
  const {
    appId,
    MarketingConsentContent
  } = useInstallerContext();
  const {
    setInstallerUiReady
  } = useRenderControl();
  const MarketingContentComponent = MarketingConsentContent;
  return /*#__PURE__*/React.createElement(GeneralUserConsentLayout, {
    width: "930px",
    height: "100%",
    maxHeight: "960px",
    onCloseButtonClick: onCloseButtonClick,
    shouldOpenNewWindow: shouldOpenNewWindow,
    removeContentPadding: true,
    content: /*#__PURE__*/React.createElement(MarketingContentComponent, {
      appId: appId,
      origin: "app-installer-client",
      onClose: onCloseButtonClick,
      onLoad: setInstallerUiReady,
      options: {
        skin: 'lean'
      }
    }),
    onAgreeButtonClick: onAgreeButtonClick,
    footnote: /*#__PURE__*/React.createElement(TermsAndConditions, {
      darkCtas: true
    })
  });
};
//# sourceMappingURL=MarketingUserConsent.js.map